import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/core";
import signupIcon from "../../assets/img/signupIcon.svg";
import verifyIcon from "../../assets/img/verifyIcon.svg";
import sendIcon from "../../assets/img/sendIcon.svg";
import Completed from "../svgs/Completed";

import { StepConnector, stepConnectorClasses, styled } from "@mui/material";

const VerticalStepper = ({ steps, activeStep, isCompleted }) => {
  //   const ICON_STYLE = {
  //     width: "42px",
  //     height: "42px",
  //     padding: "0",
  //   };

  //   const { active, completed } = props;

  const useStyles = makeStyles(() => ({
    root: {
      "&  .MuiStepLabel-root .Mui-active": {
        color: "#444554",
      },
      "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
        fill: "black",
      },
      "& .MuiStepLabel-root .Mui-completed .MuiTypography-root": {
        color: "#8246FF",
        fontFamily: "Inter",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: "35.958px",
      },
      "& .MuiStepLabel-root .Mui-active .MuiTypography-root": {
        color: "#444554",
        fontFamily: "Inter",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: "35.958px",
      },
      "& .MuiStepLabel-root .Mui-disabled .MuiTypography-root": {
        color: "#9498B5",
        fontFamily: "Inter",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "600",
        lineHeight: "35.958px",
      },
      "& .Mui-disabled .MuiStepIcon-root": {
        color: "#9498B5",
      },
      "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": {
        color: "#444554 !important",
      },
      "& .MuiStepLabel-label.Mui-disabled.MuiStepLabel-alternativeLabel": {
        color: "#9498B5 !important",
      },
      "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": {
        color: "#8246FF !important",
      },
      "& .MuiStepContent-root": {
        borderLeft: "0 !important",
        marginLeft: 0,
        paddingLeft: 0,
      },
      "& .MuiStepContent-root .MuiCollapse-wrapperInner": {
        color: " #A9ADC4",
        fontFamily: "Inter",
        fontSize: "15px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "26px",
      },
    },
  }));

  const stepperStyles = useStyles();

  const ColorlibStepIcon = ({ icon, style }) => {
    const icons = {
      1: <img src={signupIcon} alt="check" />,
      2: <img src={verifyIcon} alt="check" />,
      3: <img src={sendIcon} alt="check" />,
    };

    return <div style={style}>{icons[String(icon)]}</div>;
  };

  const completedCheck = (index, activeStep) => {
    if (activeStep > index) {
      isCompleted = true;
    }
    if (activeStep >= index + 1) {
      return Completed;
    } else {
      isCompleted = false;
      return ColorlibStepIcon;
    }
  };

  const ColorlibConnector = styled(StepConnector)(() => ({
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderLeft: "solid 2px #8246FF",
        marginLeft: "22px",
        marginBottom: "-18px",
        height: "100px",
        marginTop: "-14px",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderLeft: "solid 2px #8246FF",
        marginLeft: "22px",
        marginBottom: "-18px",
        height: "100px",
        marginTop: "-14px",
      },
    },
    [`&.${stepConnectorClasses.disabled}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderLeft: "solid 2px #eaeaf0",
        marginLeft: "22px",
        marginBottom: "-18px",
        height: "100px",
        marginTop: "-14px",
      },
    },
  }));

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        className={stepperStyles.root}
        connector={<ColorlibConnector />}
        sx={{
          ".MuiStepContent-last": {
            borderLeft: "none",
          },
        }}
      >
        {steps.map((step, index) => {
          return (
            <Step
              key={step.label}
              expanded={index === activeStep || index === activeStep + 1}
            >
              <StepLabel
                StepIconComponent={completedCheck(index, activeStep)}
                iconContainerStyle={{ width: 36 }}
                variant="caption"
              >
                <Typography>
                  {isCompleted ? step.updatedLabel : step.label}
                </Typography>
                <StepContent>{step.description}</StepContent>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {/* {activeStep === steps.length && (
        <Paper square elevation={0} sx={{ p: 3 }}>
          <Typography>All steps completed - you&apos;re finished</Typography>
         
        </Paper>
      )} */}
    </Box>
  );
};

export default VerticalStepper;
